module.exports = __webpack_public_path__ + "media/images/google_ad_manager/320x50-8c490ec6f62c21f85b2aedbae1ae53c1.png";